import {CheckOutlined} from '@ant-design/icons'
import {Col, Divider, Spin} from 'antd'
import React, {useEffect, useState} from 'react'

import {settingsApi} from 'api/settings'

import {CustomButton, CustomRow, PageTitle, Subtitle} from 'components/common'
import styles from "pages/settings/logo/settingsLogo.module.scss"
import {FormSwitch} from "components/form"
import {useHistory} from "react-router-dom"
import {routes} from "utils/routes.ts"
import {AgencyPreferences} from "api/base/api.ts"
import {createMessage} from "utils/createMessage.ts"

export const Preferences: React.FC = () => {

  const [preferences, setPreferences] = useState({} as AgencyPreferences)
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  useEffect(() => {
    setLoading(true)
    settingsApi.preferencesApi.getSettings().then(data => {
      setPreferences(data)
    }).finally(() => setLoading(false))
  }, [])

  function cancel() {
    history.push(routes.dashboard.root)
  }

  function save() {
    setLoading(true)
    settingsApi.preferencesApi.updateSettings(preferences).finally(() => {
      setLoading(false)
      createMessage('success', 'Preferences are successfully saved')
    })
  }

  return (
    <Spin spinning={loading}>
      <CustomRow marginBottom={34}>
        <Col>
          <PageTitle>Preferences</PageTitle>
        </Col>
      </CustomRow>

      <CustomRow marginBottom={4}>
        <Col>
          <Subtitle level="h2">Multiply statistics on the sampling rate value</Subtitle>
        </Col>
      </CustomRow>

      <CustomRow>
        <Col>
          <FormSwitch
            span={10}
            checked={preferences.multiplyOnSampling}
            onChange={(multiplyOnSampling) => setPreferences({...preferences, multiplyOnSampling})}
          />
        </Col>
      </CustomRow>

      <Divider className={styles.divider} />

      <CustomRow gutter={8}>
        <Col>
          <CustomButton type="primary" icon={<CheckOutlined />} onClick={save}>
            Save
          </CustomButton>
        </Col>

        <Col>
          <CustomButton type="bordered" onClick={cancel}>
            Cancel
          </CustomButton>
        </Col>
      </CustomRow>
    </Spin>
  )
}
